import React from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import { setBasePlateFactorA } from '@reducers/selectors/dimension/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
const BasePlateFactor = props => (
  <div className="calculation">
    <section className="list-type">
      <div className="base-plate-factor">
        <div className="base-plate-factor__text">
          <ul className="base-plate-factor__list">
            <li>e<sub>2</sub> &ge; &alpha; * d<sub>0</sub></li>
            <li>d<sub>0</sub>{APP_TEXTS.CLEARANCE_DIAMETER.Content}</li>
            <li>e<sub>2</sub>{APP_TEXTS.DISTANCE_TO_THE_EDGE.Content}</li>
          </ul>

          <p>
            {APP_TEXTS.SELECT_FACTOR_USED.Content}
          </p>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_SELECT_FACTOR.Content}>
          <label htmlFor="factor" className="base-plate-factor__label">
            <span>{APP_TEXTS.FACTOR.Content} &alpha;:</span>

            <select id="factor" name="factor" className="form-control" defaultValue={props.factor} onChange={props.setFactor}>
              <option value="1">1</option>
              <option value="1.2">1.2</option>
              <option value="1.25">1.25</option>
              <option value="1.5">1.5</option>
              <option value="1.75">1.75</option>
            </select>
          </label>
          </Tooltip>
        </div>

        <div className="base-plate-factor__image">
          <span className="icon_pince-picture" />
        </div>
      </div>
    </section>
  </div>
);

const mapState = state => ({
  factor: state.selectors.dimension[state.main.appType].basePlateFactor.factor_a
});

const mapDispatch = dispatch => ({
  setFactor: e => dispatch(setBasePlateFactorA(e.target.value))
});

export default connect(mapState, mapDispatch)(BasePlateFactor);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlateFactor/index.js